// extracted by mini-css-extract-plugin
export var logoImage = "b6_hK";